import { useEffect, useState } from "react";
import WebMercatorViewport from "viewport-mercator-project";
import maxBy from "lodash/maxBy";
import minBy from "lodash/minBy";

export const getMinOrMax = (markers, minOrMax, latOrLng) => {
  if (minOrMax === "max") {
    return maxBy(markers, (value) => value[latOrLng])[latOrLng];
  } else {
    return minBy(markers, (value) => value[latOrLng])[latOrLng];
  }
};

export const getBounds = (markers) => {
  const maxLat = getMinOrMax(markers, "max", "latitude");
  const minLat = getMinOrMax(markers, "min", "latitude");
  const maxLng = getMinOrMax(markers, "max", "longitude");
  const minLng = getMinOrMax(markers, "min", "longitude");

  const southWest = [minLng, minLat];
  const northEast = [maxLng, maxLat];
  return [southWest, northEast];
};

export const useMapWithViewport = ({ width, height, markers }) => {
  const [viewport, setViewport] = useState({
    width: width || 400,
    height: height || 400,
  });

  useEffect(() => {
    if (width && height && markers.length) {
      const MARKERS_BOUNDS = getBounds(markers);
      setViewport((viewport) => {
        const nextViewport = new WebMercatorViewport({
          ...viewport,
          width,
          height,
        }).fitBounds(MARKERS_BOUNDS, {
          padding: 45,
        });

        return { ...nextViewport, ...(markers.length === 1 && { zoom: 10 }) };
      });
    }
  }, [width, height]);

  const onViewportChange = (nextViewport) => {
    setViewport(nextViewport);
  };

  return {
    onViewportChange,
    viewport,
  };
};
